// Utility function to handle smooth scrolling to sections
export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

// Handle navigation from other pages to home sections
export const handleSectionNavigation = (href, navigate) => {
  if (href.startsWith('#')) {
    const sectionId = href.substring(1);
    
    // If we're not on the home page, navigate there first
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      // We're already on the home page, just scroll
      scrollToSection(sectionId);
    }
  }
};